import { DynamicDialogConfig } from 'primeng/dynamicdialog';

export const formEditorDialogConfig: DynamicDialogConfig = {
  height: '100%',
  closable: false,
  closeOnEscape: false,
  showHeader: false,
};
